<script setup>
import Spinner from '@/components/Spinner.vue';
import { useResponseMessageStore } from '@/stores/response_message';
import { socket } from '@/user.socket';
import { onBeforeUnmount, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import CashoutModal from './CashoutModal.vue';
import DefaultButton from '@/components/Buttons/DefaultButton.vue';
const { t } = useI18n()
const props = defineProps({
    ticketId: String
})

const responseMessageStore = useResponseMessageStore()
const emit = defineEmits(['accepted'])
const value = ref(0)
const cashingOut = ref(false)
const isLoadingCashout = ref(true);

const getCashoutValue = (data) => {
    if (data.ok) {
        if (data.data.ticketId == props.ticketId) {
            value.value = data.data.value
            isLoadingCashout.value = false 
        }
    }
}

const accept = () => {
    cashingOut.value = true
    socket.emit('ticket:accept-cashout', {ticketId: props.ticketId})
}

const onAccept = (data) => {
    cashingOut.value = false
    if (data.ok) {
        if (data.data.ticketId == props.ticketId) {
            emit('accepted')
        }
    } else {
        responseMessageStore.setMessage(t(data.message))
        socket.emit('ticket:calculate-cashout', {ticketId: props.ticketId})
    }
}

onMounted(() => {
    // socket.emit('ticket:calculate-cashout', {ticketId: props.ticketId})

    socket.on('ticket:calculate-cashout', getCashoutValue)

    socket.on('ticket:accept-cashout', onAccept)
})

onBeforeUnmount(() => {
    socket.off('ticket:calculate-cashout', getCashoutValue)
    socket.off('ticket:accept-cashout', onAccept)
})
const modalRef = ref(null);
const confirmCashout = () =>{
    isLoadingCashout.value = true  
    socket.emit('ticket:calculate-cashout', {ticketId: props.ticketId})
    modalRef.value.openModal();  
}
</script>

<template>
    <div class="py-2 px-4">
        <DefaultButton class="py-2.5 text-center text-black text-base font-bold rounded-lg w-full" @click="confirmCashout">
            <span>Cash Out</span>
        </DefaultButton>
        <Spinner :show="cashingOut" />
    </div>
    <CashoutModal ref="modalRef" :value="value" @accept="accept" :isLoadingCashout="isLoadingCashout"/>
</template>
